import CreateItemResponse from 'owa-service/lib/contract/CreateItemResponse';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import Message from 'owa-service/lib/contract/Message';
import itemId from 'owa-service/lib/factory/itemId';

export default function updateMessageId(automatedMessage: Message, response: CreateItemResponse) {
    let responseMessage = response.ResponseMessages.Items[0] as ItemInfoResponseMessage;
    let message = responseMessage.Items[0] as Message;

    if (message) {
        automatedMessage.ItemId = itemId({ Id: message.ItemId.Id });
    }
}
